import Analytics from '~analytics';
import facebookPixelPlugin from '~packs/analytics/src/fb-pixel';
import googleAnalyticsPlugin from '~packs/analytics/src/google-analytics';
import googleEcommercePlugin from '~packs/analytics/src/google-ecommerce';
import posthogPlugin from '~packs/analytics/src/posthog-analytics';
import getSessionId from '~packs/analytics/src/session-helper';

const analytics = Analytics({
  app: 'pay-hammer',
  version: 1,
  plugins: [
    facebookPixelPlugin({
      id: pnEnv.FACEBOOK_ID,
      dataProcessingOptions: {
        method: ['LDU'],
        country: 0,
        state: 0,
      },
    }),
    googleAnalyticsPlugin({
      measurementIds: [pnEnv.GOOGLE_ANALYTICS_V4_ID],
    }),
    googleEcommercePlugin(), // configured via google analytics plugin
    posthogPlugin({
      apiKey: pnEnv.POSTHOG_API_KEY,
    }),
  ],
});

// NOTE: Used by some simple Alpine components
window.analytics = analytics;

export { analytics, getSessionId };
